module.exports = __webpack_public_path__ + "static/chirpyest-pro-7d2b354ed82377409452b806f57d07b7.jpg";